import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const ContractModule = {
  namespaced: true,
  state: {
    currentCustomerContract: null,
    contractDismissal: null
  },
  actions: {
    async loadContractState ({ commit, state, rootGetters }, { forceUpdate }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query personalData {
          currentCustomerContract:
          currentCustomer {
            emailVerified
            dunningLevel
            friendReferralStatus {
              totalAvailableReferrals
              usedReferrals
            }
            contract {
              simCard {
                type
                status
              }
              state
              pauseInformation {
                nextStartDate
                bookedContractPauseInfo {
                  startDate
                  endDate
                  pauseStatus
                }
              }
            }
          },
          contractDismissal {
            contractDismissal
            possibleDismissal {
              nextPossibleDismissalDate
            }
            pendingDismissal {
              dismissalDate
            }
          }
        }`,
        fetchPolicy: forceUpdate ? 'network-only' : 'cache-first'
      }).then((response) => {
        state.currentCustomerContract = response.data.currentCustomerContract
        state.contractDismissal = response.data.contractDismissal
        return true
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    }
  },
  mutations: {},
  getters: {
    currentCustomerContract: state => state.currentCustomerContract,
    contractDismissal: state => state.contractDismissal
  }
}

export {
  ContractModule
}
